var map = {
	"./default/terms-of-use.html": 787,
	"./nl-BE/terms-of-use.html": 791
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 466;



//////////////////
// WEBPACK FOOTER
// ./app/views/legal/partials terms-of-use\.html$
// module id = 466
// module chunks = 8